import { getApiConstants } from '../../../utils/apiConstants';

const wizardConstants = {
    SET_PAGE: getApiConstants('SET_PAGE'),
    OVER_PAYMENT_SUBMIT: getApiConstants('OVER_PAYMENT'),
    NUMBER_OF_STEPS: 6
};

export default wizardConstants;